import Api from "../../../config/api";
import {
  SEARCH_GENERAL,
  SEARCH_GENERAL_BY_ID,
  UPDATE_GENERAL,
} from "../../../utils/constants";
import { showToast } from "../../toast/ShowToast";

export const getGeneralSetting = async (params?: any) => {
  try {
    const res = await Api(false).get(SEARCH_GENERAL, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getGeneralSettingByCompanyId = async (id?: string | null) => {
  try {
    const res = await Api(false).get(`${SEARCH_GENERAL_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const updateGeneralSetting = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(true).put(`${UPDATE_GENERAL}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
